import Vue from 'vue'
import VueRouter from 'vue-router'
// history: createWebHistory(),
import HomeView from '../HomeView.vue'
// import DpfPage from '../DpfPage.vue'
// import DpfPage2 from '../DpfPage2.vue'

const routes = [
  { path: '/', redirect: '/survey' },
  { path: '/survey', component: HomeView },
  // { path: '/dpf', component: DpfPage },
  // { path: '/dpf2', component: DpfPage2 },
]

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes
})
export default router